<template>
	<router-link to="/">
		<img src="../assets/dc_logo.svg" alt class="logo" />
	</router-link>
</template>

<script>
export default {};
</script>

<style>
.logo {
	margin-bottom: 2em;
	max-width: 280px;
}
</style>
